import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from './api';
import './AuthComponent.css';
import ChecklistModal from './ChecklistModal';
import { resetPasswordRequest } from './api';

const AuthComponent = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [username, setUsername] = useState('');
    const [isRegister, setIsRegister] = useState(false);
    const [isRegistered, setIsRegistered] = useState(false);
    const [isForgotPassword, setIsForgotPassword] = useState(false);
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAgreed, setIsAgreed] = useState(false);
    const [canAgree, setCanAgree] = useState(false);
    const modalContentRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        console.log('isRegistered', isRegistered);
        console.log('isRegister', isRegister);
        
        // URLパラメータをチェックしてメッセージを表示
        const urlParams = new URLSearchParams(window.location.search);
        const messageParam = urlParams.get('message');
        
        if (messageParam === 'registration_success') {
            setMessage('登録完了しました。続けてログインしてください。');
            // URLパラメータをクリア
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isRegister && password !== confirmPassword) {
            setMessage('パスワードが一致しません');
            return;
        }
        const endpoint = isRegister ? '/register' : '/login';
        const data = isRegister ? { username, email, password } : { email, password };
        setIsLoading(true);
        try {
            const response = await axios.post(endpoint, data);
            if (response.data.redirect) {
                window.location.href = response.data.redirect;
            } else if (isRegister && response.status === 201) {
                setIsRegistered(true);
                setMessage('');
                window.location.href = '/login?message=registration_success';
            } else if (!isRegister && response.status === 200) {
                navigate('/');
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                setMessage(error.response.data.message);
            } else {
                setMessage('An error occurred. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleLoginClick = () => {
        setIsRegistered(false);
        setIsRegister(false);
    };

    const handleForgotPasswordRequest = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await resetPasswordRequest(email);
            setMessage('パスワードリセット用のリンクをメールに送信しました。');
        } catch (error) {
            setMessage('入力されたメールアドレスは見つかりませんでした。');
        } finally {
            setIsLoading(false);
        }
    };

    const handleScroll = () => {
        if (modalContentRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = modalContentRef.current;
            if (scrollTop + clientHeight === scrollHeight) {
                setCanAgree(true);
            }
        }
    };

    const handleAgreeClick = () => {
        setIsAgreed(true);
        setIsModalOpen(false);
    };

    useEffect(() => {
        if (modalContentRef.current) {
            const { scrollHeight, clientHeight } = modalContentRef.current;
            if (scrollHeight <= clientHeight) {
                setCanAgree(true);
            } else {
                modalContentRef.current.addEventListener('scroll', handleScroll);
            }
        }
        return () => {
            if (modalContentRef.current) {
                modalContentRef.current.removeEventListener('scroll', handleScroll);
            }
        };
    }, [isModalOpen]);

    return (
        <div className="auth-container">
            <div className="auth-logo-container">
                <div className="auth-logo">
                    <img src="logo_imavorec.png" alt="imavo Logo" />
                </div>
            </div>
            <div className="auth-form-container">
                <div className="auth-notice">
                    imavoとimavo RECのアカウントが統合されました。同じメールアドレス・パスワードで両サービスにログインできます。以前両方のサービスをご利用だった方は、imavoのパスワードでログインしてください。
                </div>
                {isForgotPassword ? (
                    <>
                        <h2>パスワードをお忘れの方</h2>
                        <form onSubmit={handleForgotPasswordRequest} className="auth-form">
                            <label className="auth-label">メールアドレス</label>
                            <input
                                type="email"
                                placeholder="abc@imavo.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="auth-input"
                                required
                            />
                            <button type="submit" className="auth-button" disabled={isLoading}>
                                {isLoading ? <span className="auth-spinner" /> : '送信'}
                            </button>
                        </form>
                        <button onClick={() => { setIsForgotPassword(false); setMessage(''); }} className="auth-switch-button">
                            ログインに戻る
                        </button>
                        {message && <p className="auth-message">{message}</p>}
                    </>
                ) : (
                <>
                <h2>imavo RECに{isRegister ? '新規登録する' : 'ログインする'}</h2>
                <form onSubmit={handleSubmit} className="auth-form">
                    {isRegister && (
                        <>
                            <label className="auth-label">ユーザーネーム</label>
                            <input
                                type="text"
                                placeholder="イマーボ"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="auth-input"
                            />
                        </>
                    )}
                    <label className="auth-label">メールアドレス</label>
                    <input
                        type="email"
                        placeholder="abc@imavo.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="auth-input"
                    />
                    <label className="auth-label">パスワード</label>
                    <input
                        type="password"
                        placeholder="******"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="auth-input"
                    />
                    {isRegister && (
                        <>
                            <label className="auth-label">パスワード（再入力）</label>
                            <input
                                type="password"
                                placeholder="******"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="auth-input"
                            />
                        </>
                    )}
                    {isRegister && (
                        <>
                            <a href="#" onClick={() => setIsModalOpen(true)} className="auth-link">確認事項を表示する（必須）</a>
                            <ChecklistModal
                                isOpen={isModalOpen}
                                onClose={() => setIsModalOpen(false)}
                                onAgree={() => {
                                    setIsAgreed(true);
                                    setIsModalOpen(false);
                                }}
                            />
                        </>
                    )}
                    <button type="submit" className="auth-button" disabled={(isRegister && !isAgreed) || isLoading}>
                        {isLoading ? <span className="auth-spinner" /> : (isRegister ? '登録' : 'ログイン')}
                    </button>
                </form>
                <p>
                    <button onClick={() => setIsRegister(!isRegister)} className="auth-switch-button">
                        {isRegister ? 'ログインはこちら' : '新規登録はこちら'}
                    </button>
                </p>
                {!isRegister && (
                    <p>
                        <button onClick={() => { setIsForgotPassword(true); setMessage(''); }} className="auth-switch-button">
                            パスワードをお忘れの方
                        </button>
                    </p>
                )}
                {message && <p className="auth-message">{message}</p>}
                </>
                )}
            </div>
        </div>
    );
};

export default AuthComponent;
